import Loadable from 'app/components/Loadable';
import { lazy } from 'react';

const CommissionList = Loadable(lazy(() => import('./CommissionList.jsx')));
const CommissionDetails = Loadable(lazy(() => import('./CommissionDetails.jsx')));
const CommissionSort = Loadable(lazy(() => import('./CommissionSort.jsx')));

export const commisionRoutes = [
  { path: '/transport-allowance/list', element: <CommissionList /> },
  { path: '/transport-allowance/list/details', element: <CommissionDetails /> },
  { path: '/transport-allowance/list/sorting', element: <CommissionSort /> },
];
